import React from 'react';
import useAddPartnersDetails from './hooks';
import AddHeader from '../../../../components/layout/header/add';
import PartnersPartner from './partner';
import PartnersContactPerson from './contact-person';
import Button from '../../../../components/molecules/buttons';

function AddPartnersDetail() {
  const {
    partner, partnerId, formik, onNavigateBack, addLoad, onNavigateLanding,
  } = useAddPartnersDetails();

  const renderFormContent = () => (
    <div>
      <AddHeader
        primary={{ route: '/partners', title: 'Partner' }}
        secondary={partnerId ? {
          route: `/partners/${partnerId}`,
          title: partner.data?.name,
        } : undefined}
        title={!partnerId ? 'Add Partner' : 'Edit Partner'}
      />
      <PartnersPartner formikParent={partnerId ? undefined : formik} />
      <div className="w-100 bg-stroke mb-4" style={{ height: '7px' }} />
      {partner.data?.contactPerson?.length && partner.data?.contactPerson?.filter((contact) => contact.deleted === 0).map((contact) => (
        <div key={contact.id}>
          <PartnersContactPerson contactId={contact.id} />
          <div className="w-100 bg-stroke mb-4" style={{ height: '7px' }} />
        </div>
      ))}
      {!partnerId && <PartnersContactPerson formikParent={formik} />}
      <div className={!partnerId ? 'w-100 bg-stroke mb-4' : 'd-none'} style={{ height: '7px' }} />
      <div className="d-flex justify-content-end px-4 px-xl-5 pb-4">
        <div style={partnerId ? { width: '200px' } : { width: '200px', marginRight: '20px' }}>
          <Button.Default
            id="cancel"
            type="button"
            label="Cancel"
            size="lg"
            outline
            onClick={partnerId ? onNavigateBack : onNavigateLanding}
          />
        </div>
        <div style={partnerId ? { display: 'none' } : { width: '200px' }}>
          <Button.Default
            id="save"
            type="submit"
            label="Save Changes"
            size="lg"
            loading={addLoad}
          />
        </div>
      </div>
    </div>
  );

  if (!partnerId) {
    return (
      <form onSubmit={formik.handleSubmit}>
        {renderFormContent()}
      </form>
    );
  }
  return renderFormContent();
}

export default AddPartnersDetail;
